module.exports = __webpack_public_path__ + "img/newchris-94.6eec8126.jpg";